import ActivityLog from '../assets/MyDrive/Activity Log.png';
import AdminDashboard from "../assets/MyDrive/Admin dashboard.png";
import LoginView from "../assets/MyDrive/Login.png";
import StorageReport from "../assets/MyDrive/Storage Report.png";
import TrashView from "../assets/MyDrive/Trash.png";
import AdminUserProfile from "../assets/MyDrive/Admin User Profile.png";
import AdminUserProfile2 from "../assets/MyDrive/Admin User Profile 2.png";
import ChangeRole from "../assets/MyDrive/Change Role.png";
import CopyFile from '../assets/MyDrive/Copy File.png';
import DeleteConfirmation from '../assets/MyDrive/Delete Confirmation.png';
import DriveView from '../assets/MyDrive/Drive View.png';
import DriveDark from '../assets/MyDrive/Drive dark.png';
import ImagePreview from '../assets/MyDrive/Image Preview.png';
import ShareFile from '../assets/MyDrive/Share File.png';
import FileUploaded from '../assets/MyDrive/File Uploaded.png';
import MoveFile from '../assets/MyDrive/Move File.png';
import RenameModal from '../assets/MyDrive/Rename modal.png';
import UploadedFolder from '../assets/MyDrive/Uploaded Folder.png';
import UserManagement from '../assets/MyDrive/User Management.png';
import DemoUserProfile from '../assets/MyDrive/Demo User Profile.png';
import Register from '../assets/MyDrive/Register.png';
import FileMenu from '../assets/MyDrive/File Menu.png';
import FileManagement from '../assets/MyDrive/File management.png';
import Filter from '../assets/MyDrive/Filter.png';
import SelectMultipleFiles from '../assets/MyDrive/Select multiple files.png';
import EmptiedTrash from '../assets/MyDrive/Emptied Trash.png';
import ItemsMovedToTrash from '../assets/MyDrive/Items moved to trash.png';
import ListView from '../assets/MyDrive/List view.png';
import Properties from '../assets/MyDrive/Properties.png';
import SearchDark from '../assets/MyDrive/Search Dark.png';
import UploadingFile from '../assets/MyDrive/Uploading File.png';
import UserManagementRoleChange from '../assets/MyDrive/User Management after Role change.png';
import UploadTransferModal from '../assets/MyDrive/upload transfer modal.png';


export const projectsData = [
  {
    id: 1,
    title: "My Drive",
    problem: "User do not have a secure and private place to store their files.",
    description: "A full-stack cloud storage solution with advanced file management, sharing capabilities, and chunked uploads for large files.",
    tech: ["React.js","React Router", "UseContext","Axios","ExpressJS","JWT","bcrypt","Multer","Nodemailer","JavaScript", "Redis", "Node.js"],
    media: [
     LoginView,
     Register,
     DriveDark,
     DriveView,
     AdminDashboard,
     ActivityLog,
     StorageReport,
     TrashView,
     AdminUserProfile,
     AdminUserProfile2,
     UserManagement,
     DemoUserProfile,
     ChangeRole,
     FileManagement,
     FileMenu,
     CopyFile,
     MoveFile,
     DeleteConfirmation,
     RenameModal,
     ShareFile,
     Filter,
     SelectMultipleFiles,
     ImagePreview,
     FileUploaded,
     UploadedFolder,
     EmptiedTrash,
     ItemsMovedToTrash,
     ListView,
     Properties,
     SearchDark,
     UploadingFile,
     UserManagementRoleChange,
     UploadTransferModal
    ],
    image: DriveDark,
    links: {
      demo: "https://drive.sushantpardhi.in",
      code: "https://github.com/sushantpardhi/MyDrive"
    },
    features: [
     "File & Folder Management - Organize files in hierarchical folders",
     "Chunked File Upload - Support for large files with resume capability",
     "Secure Authentication - JWT-based authentication with bcrypt hashing",
     "Email Notifications - Welcome emails, password reset, and sharing alerts",
     "Password Reset - Secure token-based password recovery",
     "File Sharing - Share files/folders with other users via email",
      "Trash Management - Soft delete with restore functionality",
     "Responsive Design - Optimized for desktop and mobile devices",
     "Search - Find files and folders quickly",
     "Storage Management - Track storage usage and limits",
    ]
  }
];
